import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';


// Constants

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';

// Types

import { SsapData } from '../../../SsapTypes';

interface VoterRegistrationAttestationProps {
    actions: {
        onFieldChange_data: Function,
    },
    data: SsapData,
    formName: string
}

const VoterRegistrationAttestation = (props: VoterRegistrationAttestationProps): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            legalAttestations: {
                voterRegistration
            }
        },
        formName
    } = props;

    return (
        <>
            <UniversalInput
                legend = { {
                    legendText: 'ssap.input.legend.voter_registration',
                    dataInstructions: 'instructional_text.voter_registration',
                }}
                label = { {
                    showRequiredIcon: false
                } }
                inputData = { {
                    isInputRequired: false,
                    type: INPUT_TYPES.RADIO_BUTTONS,
                    name: 'voterRegistration',
                    value: voterRegistration,
                    options: DROPDOWN_OPTIONS.VOTER_REGISTRATION,
                    currentData: data,
                    fields: [ 'legalAttestations' ]
                }}
                inputActions = { {
                    onFieldChange: onFieldChange_data
                } }
                underFormControl
                parentForm = { { name: formName } }
            />
            <FormattedMessage id = 'footer_text.voter_registration' />
        </>
    );
};

export default VoterRegistrationAttestation;